import { examIdSchema, patientIdSchema } from "@repo/api/schemas";
import { useExamAdministration } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { ExamAdministrationDetail } from "@/features/assessments";

export const Route = createFileRoute("/patients/$patientId/_layout/assessments/e/$examId")({
  component: RouteComponent,
});

function RouteComponent() {
  const examId = examIdSchema.parse(Route.useParams().examId);
  const exam = useExamAdministration({ examId, patientId: patientIdSchema.parse(Route.useParams().patientId) });

  if (!exam) {
    return <div className="p-6 text-sm text-muted-foreground">Exam not found.</div>;
  }

  return <ExamAdministrationDetail exam={exam} />;
}
